module.exports = __webpack_public_path__ + "img/eco_worthy_50Ah.b823cb37.png";